import React from 'react';
import AdminPromptsTable from 'components/admin/prompts/AdminPromptsTable';

const AdminPromptsPage = () => {
  return <AdminPromptsTable />;
};

export default AdminPromptsPage;
